<template>
  <header class="p-6">
    <div class="mb-6 grid place-content-center rounded-lg bg-primary-50 p-6">
      <app-image alt="" class="max-h-[200px]" :src="prependImage" />

      <app-dialog-close-button
        v-if="closeButton"
        class="absolute right-1 top-1"
        @click="$emit('close')"
      />
    </div>

    <dialog-title class="mb-1 text-xl font-bold">
      <slot name="title">
        {{ title }}
      </slot>
    </dialog-title>

    <dialog-description
      v-if="subtitle || $slots.subtitle"
      class="text-sm text-subtle"
    >
      <slot name="subtitle">
        {{ subtitle }}
      </slot>
    </dialog-description>
  </header>
</template>

<script lang="ts" setup>
import { DialogDescription, DialogTitle } from "@headlessui/vue";
import type { TranslateResult } from "vue-i18n";

defineProps<{
  title?: TranslateResult;
  subtitle?: TranslateResult;
  prependImage: string;
  closeButton: boolean;
}>();

defineEmits(["close"]);
</script>
